(() => {
  if (window.__elagiliWishlistAccount) return;
  window.__elagiliWishlistAccount = true;

  const KEY = 'elagili_wishlist_v1';
  const ENDPOINT = '/apps/elagili-tracking/wishlist';
  let accountLoggedIn = false;
  let accountReady = false;
  let saveTimer = null;

  const cleanId = (id) => String(id || '').replace(/^gid:\/\/shopify\/Product\//, '').trim();
  const normalizeItem = (item) => {
    if (!item || typeof item !== 'object') return null;
    const id = cleanId(item.id);
    if (!id) return null;
    return {
      id,
      title: String(item.title || 'Product'),
      url: String(item.url || '#'),
      image: String(item.image || ''),
      price: String(item.price || '')
    };
  };
  const dedupe = (items) => {
    const out = [], seen = new Set();
    for (const raw of (Array.isArray(items) ? items : [])) {
      const item = normalizeItem(raw);
      if (!item || seen.has(item.id)) continue;
      seen.add(item.id);
      out.push(item);
    }
    return out;
  };
  const read = () => {
    try { return dedupe(JSON.parse(localStorage.getItem(KEY) || '[]')); }
    catch (_) { return []; }
  };
  const writeLocal = (items) => {
    localStorage.setItem(KEY, JSON.stringify(dedupe(items)));
    refresh();
  };
  const queueAccountSave = () => {
    if (!accountLoggedIn || !accountReady) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(async () => {
      try {
        await fetch(ENDPOINT, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ wishlist: read() })
        });
      } catch (_) {}
    }, 250);
  };
  const write = (items) => {
    writeLocal(items);
    queueAccountSave();
  };

  const ensureButtons = (root = document) => {
    root.querySelectorAll?.('product-card').forEach((card) => {
      let button = card.querySelector('.elagili-wishlist-btn--card');
      if (!button) {
        const id = cleanId(card.dataset.productId);
        if (!id) return;
        const link = card.querySelector('.product-card__link[href]');
        const img = card.querySelector('img');
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'elagili-wishlist-btn--card';
        button.dataset.wishlistId = id;
        button.dataset.wishlistTitle = card.querySelector('.visually-hidden')?.textContent?.trim() || 'Product';
        button.dataset.wishlistUrl = link?.getAttribute('href') || '#';
        button.dataset.wishlistImage = img?.currentSrc || img?.src || '';
        button.setAttribute('aria-label', 'Add to Wishlist');
        button.setAttribute('aria-pressed', 'false');
        button.innerHTML = '<span aria-hidden="true">♡</span>';
      }

      // Anchor the heart to the image, not the changing height of the card title.
      const gallery = card.querySelector('.card-gallery:has(img)');
      const host = gallery || card.querySelector('.product-card__content') || card;
      if (button.parentElement !== host) host.appendChild(button);
      host.style.setProperty('position', 'relative', 'important');
      button.style.setProperty('position', 'absolute', 'important');
      button.style.setProperty('top', gallery ? 'auto' : '10px', 'important');
      button.style.setProperty('right', '10px', 'important');
      button.style.setProperty('bottom', gallery ? '10px' : 'auto', 'important');
      button.style.setProperty('left', 'auto', 'important');
      button.style.setProperty('display', 'grid', 'important');
      button.style.setProperty('visibility', 'visible', 'important');
      button.style.setProperty('opacity', '1', 'important');
      button.style.setProperty('pointer-events', 'auto', 'important');
      button.style.setProperty('z-index', '2147480000', 'important');
    });
  };

  const installStyles = () => {
    if (document.getElementById('elagili-wishlist-account-styles')) return;
    const style = document.createElement('style');
    style.id = 'elagili-wishlist-account-styles';
    style.textContent = `
      .elagili-wishlist-btn--card{width:38px!important;height:38px!important;place-items:center!important;border:1px solid rgba(53,69,87,.2)!important;border-radius:999px!important;background:rgba(255,255,255,.96)!important;color:#354557!important;box-shadow:0 3px 12px rgba(0,0,0,.09)!important;cursor:pointer!important}
      .elagili-wishlist-btn--card span{font-size:24px!important;line-height:1!important}.elagili-wishlist-btn--card.is-active{color:#D62828!important}
      .elagili-wishlist-launcher{position:fixed;left:18px;bottom:96px;z-index:90;width:52px;height:52px;border:0;border-radius:999px;background:#354557;color:#fff;display:grid;place-items:center;box-shadow:0 7px 24px rgba(0,0,0,.22);cursor:pointer}
      .elagili-wishlist-launcher>span:first-child{font-size:23px;line-height:1}.elagili-wishlist-count{position:absolute;right:-2px;top:-4px;min-width:20px;height:20px;padding:0 5px;border-radius:999px;background:#D62828;color:#fff;font-size:11px;display:grid;place-items:center;font-weight:700}
      .elagili-wishlist-overlay{position:fixed;z-index:160;inset:0;background:rgba(20,27,34,.38);opacity:0;visibility:hidden;transition:.2s ease}.elagili-wishlist-overlay.is-open{opacity:1;visibility:visible}
      .elagili-wishlist-drawer{position:absolute;right:0;top:0;height:100%;width:min(420px,92vw);background:#fff;box-shadow:-10px 0 30px rgba(0,0,0,.14);transform:translateX(100%);transition:.22s ease;display:flex;flex-direction:column}.elagili-wishlist-overlay.is-open .elagili-wishlist-drawer{transform:translateX(0)}
      .elagili-wishlist-drawer__head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #e5e8eb;font-size:20px;color:#263441}.elagili-wishlist-close{border:0;background:transparent;font-size:30px;line-height:1;cursor:pointer;color:#354557}
      .elagili-wishlist-items{padding:12px 18px 28px;overflow:auto}.elagili-wishlist-empty{padding:34px 8px;text-align:center;color:#6d7780}.elagili-wishlist-item{display:grid;grid-template-columns:82px 1fr;gap:13px;padding:13px 0;border-bottom:1px solid #eef1f4}.elagili-wishlist-item__image{width:82px;height:82px;border-radius:10px;overflow:hidden;background:#f5f6f7;display:block}.elagili-wishlist-item__image img{width:100%;height:100%;object-fit:contain}.elagili-wishlist-item__title{display:block;color:#263441;text-decoration:none;font-weight:600;line-height:1.35}.elagili-wishlist-item__price{margin-top:5px;color:#354557;font-weight:600}.elagili-wishlist-remove{margin-top:7px;padding:0;border:0;background:transparent;color:#D62828;text-decoration:underline;cursor:pointer;font:inherit;font-size:13px}
      @media(max-width:749px){.elagili-wishlist-btn--card{width:34px!important;height:34px!important}.elagili-wishlist-btn--card span{font-size:21px!important}.elagili-wishlist-launcher{left:12px;bottom:82px;width:48px;height:48px}}
    `;
    document.head.appendChild(style);
  };

  const toggle = (button) => {
    const id = cleanId(button.dataset.wishlistId);
    if (!id) return;
    const items = read();
    const index = items.findIndex((item) => item.id === id);
    if (index >= 0) items.splice(index, 1);
    else {
      const card = button.closest('product-card');
      items.unshift({
        id,
        title: button.dataset.wishlistTitle || card?.querySelector('.visually-hidden')?.textContent?.trim() || 'Product',
        url: button.dataset.wishlistUrl || card?.querySelector('.product-card__link[href]')?.getAttribute('href') || '#',
        image: button.dataset.wishlistImage || card?.querySelector('img')?.currentSrc || card?.querySelector('img')?.src || '',
        price: card?.querySelector('.elagili-card-price')?.textContent?.replace(/\s+/g, ' ')?.trim() || ''
      });
    }
    write(items);
  };

  const createDrawer = () => {
    if (document.querySelector('.elagili-wishlist-launcher')) return;
    const launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'elagili-wishlist-launcher';
    launcher.setAttribute('aria-label', 'Open Wishlist');
    launcher.innerHTML = '<span aria-hidden="true">♥</span><span class="elagili-wishlist-count">0</span>';
    const overlay = document.createElement('div');
    overlay.className = 'elagili-wishlist-overlay';
    overlay.innerHTML = '<aside class="elagili-wishlist-drawer" role="dialog" aria-modal="true" aria-label="Wishlist"><div class="elagili-wishlist-drawer__head"><strong>Wishlist</strong><button type="button" class="elagili-wishlist-close" aria-label="Close Wishlist">×</button></div><div class="elagili-wishlist-items"></div></aside>';
    launcher.addEventListener('click', () => overlay.classList.add('is-open'));
    overlay.addEventListener('click', (event) => { if (event.target === overlay) overlay.classList.remove('is-open'); });
    overlay.querySelector('.elagili-wishlist-close').addEventListener('click', () => overlay.classList.remove('is-open'));
    document.body.append(launcher, overlay);
  };

  const esc = (value) => String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const renderDrawer = () => {
    const items = read();
    const count = document.querySelector('.elagili-wishlist-count');
    if (count) count.textContent = String(items.length);
    const box = document.querySelector('.elagili-wishlist-items');
    if (!box) return;
    if (!items.length) { box.innerHTML = '<div class="elagili-wishlist-empty">Your Wishlist is empty.</div>'; return; }
    box.innerHTML = items.map((item) => `<div class="elagili-wishlist-item"><a class="elagili-wishlist-item__image" href="${esc(item.url)}">${item.image ? `<img src="${esc(item.image)}" alt="">` : ''}</a><div><a class="elagili-wishlist-item__title" href="${esc(item.url)}">${esc(item.title)}</a>${item.price ? `<div class="elagili-wishlist-item__price">${esc(item.price)}</div>` : ''}<button type="button" class="elagili-wishlist-remove" data-id="${esc(item.id)}">Remove</button></div></div>`).join('');
  };

  const refresh = () => {
    ensureButtons(document);
    const saved = new Set(read().map((item) => item.id));
    document.querySelectorAll('.elagili-wishlist-btn--card').forEach((button) => {
      const active = saved.has(cleanId(button.dataset.wishlistId));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remove from Wishlist' : 'Add to Wishlist');
      const heart = button.querySelector('span');
      if (heart) heart.textContent = active ? '♥' : '♡';
    });
    renderDrawer();
  };

  const syncAccount = async () => {
    try {
      const response = await fetch(ENDPOINT, { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      if (!data?.success || !data.logged_in) return;
      accountLoggedIn = true;
      const merged = dedupe([...(Array.isArray(data.wishlist) ? data.wishlist : []), ...read()]);
      writeLocal(merged);
      accountReady = true;
      queueAccountSave();
    } catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest('.elagili-wishlist-btn--card');
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggle(wishlistButton);
      return;
    }
    const removeButton = event.target.closest('.elagili-wishlist-remove');
    if (removeButton) {
      const id = cleanId(removeButton.dataset.id);
      write(read().filter((item) => item.id !== id));
    }
  });
  document.addEventListener('shopify:section:load', (event) => { ensureButtons(event.target || document); refresh(); });

  const init = () => {
    installStyles();
    createDrawer();
    ensureButtons(document);
    refresh();
    if ('requestIdleCallback' in window) requestIdleCallback(() => syncAccount(), { timeout: 2000 });
    else setTimeout(() => syncAccount(), 700);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();